export enum CustomerTypeRouteName {
    Index = 'system.customer.type.index',
    Create = 'system.customer.type.create',
    Edit = 'system.customer.type.edit',
}

export default {
    path: 'customer/types',
    name: CustomerTypeRouteName.Index,
    component: () => import('@/views/system/customer/type/Index.vue'),
    meta: {
        auth: true,
        label: 'Customer Types',
        icon: 'fal fa-user-tag fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-customer-types',
    },
    children: [
        {
            path: 'create',
            name: CustomerTypeRouteName.Create,
            component: () => import('@/views/system/customer/type/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Customer Type',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-customer-types',
            },
        },
        {
            path: ':customerTypeId/edit',
            name: CustomerTypeRouteName.Edit,
            component: () => import('@/views/system/customer/type/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Customer Type',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-customer-types',
            },
        },
    ],
}
